import { useState, useEffect, useReducer } from "react";
import { db } from "../firebase/config";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { uploadToCloudinary } from "../services/upload";

const enviroment = process.env.REACT_APP_ENVIROMENT;

const initialState = { loading: null, error: null };

const insertReducer = (state, action) => {
  switch (action.type) {
    case "LOADING": return { loading: true, error: null };
    case "ERROR": return { loading: false, error: action.payload };
    case "INSERTED_DOC": return { loading: false, error: null };
    default: return state;
  }
};

export const useInsertDocument = (docCollection) => {
  const [response, dispatch] = useReducer(insertReducer, initialState);
  const [cancelled, setCancelled] = useState(false);

  const checkCancelBeforeDispatch = (action) => {
    if (enviroment === "prod" ? !cancelled : cancelled) dispatch(action);
  };

  const insertDocument = async (document, file) => {
    checkCancelBeforeDispatch({ type: "LOADING" });
    try {
      let fileUrl = null;
      if (file) {
        fileUrl = await uploadToCloudinary(file);
      }

      const newDocument = { 
        ...document, 
        imagem: fileUrl || (document.imagem || ""), 
        createdAt: Timestamp.now() 
      };

      const insertedDoc = await addDoc(collection(db, docCollection), newDocument);

      checkCancelBeforeDispatch({ type: "INSERTED_DOC", payload: insertedDoc });
    } catch (error) {
      checkCancelBeforeDispatch({ type: "ERROR", payload: error.message });
    }
  };

  useEffect(() => () => setCancelled(true), []);
  return { insertDocument, response };
};